var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[(!_vm.oauth)?_c('app-header'):_vm._e(),_c('div',{staticClass:"mb-5",attrs:{"id":"content"}},[_c('router-view'),_c('flash-message')],1),(!_vm.oauth)?_c('footer',{staticClass:"d-flex align-items-end flex-column text-light"},[_c('version')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }